import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable, of } from 'rxjs';
import { catchError, map, tap } from 'rxjs/operators';
// import { ConstantsService } from './constant.service';
import { environment } from 'src/environments/environment';

@Injectable({
	providedIn: 'root'
})
export class UsersService {

	constructor(private http: HttpClient) { }

	getUserInfo(toyotaGUID:any): Observable<any> {
		const httpCustomOptions = {
			headers: new HttpHeaders({
				'Content-Type': 'application/json, application/x-www-form-urlencoded;charset=ISO-8859-15',
				'Accept': 'application/json',
			})
		};
		return this.http
			.get(`${environment.baseAPIURL}/getUserDetails/${toyotaGUID}`, httpCustomOptions)
			.pipe(
				tap(_ => this.log('data success')),
				catchError(this.handleError<any>('data fails'))
			);
	}

	getUserInfoFreeze(toyotaGUID:any): Promise<any> {
		const httpCustomOptions = {
			headers: new HttpHeaders({
				'Content-Type': 'application/json, application/x-www-form-urlencoded;charset=ISO-8859-15',
				'Accept': 'application/json',
			})
		};
		return this.http
			.get(`${environment.baseAPIURL}/getUserDetails/${toyotaGUID}`, httpCustomOptions)
			.pipe(map(res => res))
			.toPromise();
	}


	private handleError<T>(operation:any, result?: T) {
		return (error: any): Observable<T> => {
			console.error(error); // log to console instead
			return of(result as T);
		};
	}

	/** Log a message */
	private log(message: string) {
		console.log(message)
	}


}
